import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'tmm_cookie_consent';

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (consent === 'accepted') {
      enableAnalytics();
    } else if (!consent) {
      setVisible(true);
    }
  }, []);

  const enableAnalytics = () => {
    if (window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
    }
    // Load X (Twitter) Pixel uwt.js once consent is granted (idempotent)
    if (!window.__twq_loaded) {
      window.__twq_loaded = true;
      const s = document.createElement('script');
      s.async = true;
      s.src = 'https://static.ads-twitter.com/uwt.js';
      document.head.appendChild(s);
      if (window.twq) window.twq('config', 'rcasv');
    }
  };

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    enableAnalytics();
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-[9999] p-4 md:p-0"
    >
      <div className="max-w-2xl mx-auto mb-4 md:mb-6 p-5 bg-black/95 border border-white/10 backdrop-blur-md flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-white/60 text-sm flex-1">
          We use cookies to analyze site traffic and improve your experience.
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={handleDecline}
            data-testid="cookie-decline-btn"
            className="px-4 py-2 text-white/40 text-xs font-semibold uppercase tracking-wider hover:text-white/60 transition-colors duration-300"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            data-testid="cookie-accept-btn"
            className="px-5 py-2 bg-green-500 text-black text-xs font-bold uppercase tracking-wider hover:bg-green-400 transition-colors duration-300"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};
